import React, { createContext, ReactNode, useState } from 'react';

type PWAEventType = {
  event: any;
};

type PWAContextType = {
  state: PWAEventType;
  setState: React.Dispatch<React.SetStateAction<PWAEventType>>;
};

const DEFAULT_VALUE = {
  state: {
    event: null,
  },
  setState: () => {},
};

const PWAContext = createContext<PWAContextType>(DEFAULT_VALUE);

const PWAContextProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState({ event: null });

  const handler = (e: any) => {
    e.preventDefault();
    setState({ ...state, event: e });
  };

  window.addEventListener('beforeinstallprompt', handler);

  return (
    <PWAContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </PWAContext.Provider>
  );
};

export { PWAContextProvider };
export default PWAContext;
